




















































import {
    defineComponent,
    computed,
} from '@vue/composition-api';
import { isMobileLayout } from '@superbet-group/web.lib.vue-utilities';
import FooterColumnsTitle from './FooterColumnsTitle.vue';
import { shellLocalConfig } from '@src/config/shell/localConfig';
import {
    SdsLink,
    SdsContentLoader,
} from '@superbet-group/web.lib.ui-components';

export default defineComponent({
    name: 'SponsoredEntities',
    props: {
        sponsoredEntities: {
            type: Array,
            required: false,
            default: () => ([]),
        },
        isLoadingLogos: {
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        const isMobile = computed(() => isMobileLayout());

        const gapSize = computed(() => {
            if (props.sponsoredEntities.length < 5) {
                return '24px';
            } else {
                return isMobile.value ? '16px' : '8px';
            }
        });
        return {
            gapSize,
            hasSponsorshipTitle: shellLocalConfig.hasSponsorshipTitle,
            hasSponsorshipSubtitle: shellLocalConfig.hasSponsorshipSubtitle,
        };
    },
    components: {
        FooterColumnsTitle,
        SdsLink,
        SdsContentLoader,
    },
});
